<template>
  <div class="container">
    <div class="restaurant">

      <div class="header-desktop-container header-desktop-container-mobile">
        <div class="d-flex align-center">
          <!-- <router-link style="margin: auto" v-if="user &&
            user.roles &&
            user.roles.length > 0 &&
            user.roles[0].employeeRole === 'Root'
            " to="/RestaurantRoot">
            <img src="../assets/img/arrowBack.svg" class="img-pluss-btn" alt="arrow-back" />
          </router-link> -->
          <router-link style="margin: auto" to="/RestaurantRoot">
            <img src="../assets/img/arrowBack.svg" class="img-pluss-btn" alt="arrow-back" />
          </router-link>
          <h1 class="page-title">
            {{ this.restaurant.name }}
            <span class="restaurant-title-adress">({{ this.restaurant.address }})</span>
          </h1>
        </div>
        <div class="d-flex align-center button-container">
          <div v-if="dataChanged" class="d-flex align-center">
            <p class="warning-red">Есть несохраненые изменения!</p>

          </div>
          <button v-if="hasLinks" @click="copyLink('app')" class="btn-qr">
            AppQR
            <img class="save-icon" src="../assets/icons/qr 1.svg" alt="app_qr" />
          </button>

          <button @click="copyLink('menu')" class="btn-qr">
            MenuQR
            <img class="save-icon" src="../assets/icons/menu 1.svg" alt="menu_qr" />
          </button>
          <button @click="editRestaurant" class="btn-save">
            Сохранить
            <img class="save-icon" src="../assets/img/btn-save.svg" alt="save" />
          </button>
        </div>

      </div>

      <template>
        <!-- <div>
          <Summary @data-changed="updateDataChangedState" :responseData="restaurant" />
          
        </div> -->
        <div class="container-main">
          <div class="content-container">
            <div class="box-container">
              <h2 class="information-title">Информация</h2>

              <div class="horizontal-line"></div>

              <div class="col-content rest-name-container">
                <p class="col-title">Название ресторана <span class="red-dot">*</span></p>
                <input class="input-css" v-model="name" placeholder="---" @input="onInputChange">
              </div>


              <div class="col-content desc-rest-container">
                <p class="col-title">Описание ресторана <span class="red-dot">*</span></p>
                <textarea class="input-css-textarea" v-model="description" placeholder="---"
                  @input="onInputChange"></textarea>
              </div>

              <div class="search-component">
                <p class="col-title">Юридическое лицо <span class="red-dot">*</span></p>
                <v-autocomplete v-model="account" placeholder="---" :items="accounts" item-text="name" item-value="id"
                  hide-details solo id="restaurant-selector" class="input-css" @change="onChangeAccount">
                  <template v-slot:item="{ item, isSelected }">
                    <div :class="['restaurant-item', { 'active': isSelected }]">
                      {{ item.name }}
                    </div>
                  </template>
                </v-autocomplete>
              </div>
              <div class="col-content phonenumber-container">
                <p class="col-title"> Номер телефона для связи клиентов <span class="red-dot">*</span></p>
                <input class="input-css" @input="(event) => { onInputChange(event); }" v-model="phoneNumber"
                  placeholder="+7(" v-mask="'+7 (###) ###-##-##'">
              </div>

              <div class="search-component">
                <p class="col-title">Выбор приложения <span class="red-dot">*</span></p>
                <v-autocomplete v-model="application" placeholder="---" :items="applications" item-text="brandName"
                  item-value="id" hide-details solo id="application-selector" class="input-css" @change="onChangeApp">
                  <template v-slot:item="{ item, isSelected }">
                    <div :class="['restaurant-item', { 'active': isSelected }]">
                      {{ item.brandName }}
                    </div>
                  </template>
                </v-autocomplete>
              </div>
              <div class="col-content adress-container">
                <p class="col-title">Адрес <span class="red-dot">*</span></p>
                <input class="input-css" v-model="address" placeholder="---" @input="onInputChange" />
              </div>

              <div class="col-content minorder-container">
                <p class="col-title">Минимальная сумма заказа <span class="red-dot">*</span></p>
                <cleave v-model="minOrderAmount" :options="cleaveOptions" class="input-css" placeholder="---" />
              </div>

              <div class="deliverty-title-margin">
                <p class="delivery-title">Доставка</p>
              </div>
              <div class="d-flex align-center justify-space-between">
                <p class="delivery-text">{{
                  isUsingDelivery ? "Используется" : "Не используется"
                }}</p>
                <div class="">
                  <input type="checkbox" hidden="hidden" id="discount" v-model="isUsingDelivery"
                    @change="isUsingDeliveryLog" />
                  <label class="switch" for="discount"></label>
                </div>
              </div>

              <div class="loyal-margin">
                <p class="delivery-title">Лояльность</p>
              </div>
              <div class="d-flex align-center justify-space-between">
                <p class="delivery-text">{{
                  isUsingBonus ? "Используется" : "Не используется"
                }}</p>
                <div class="">
                  <input type="checkbox" hidden="hidden" id="bonus" v-model="isUsingBonus"
                    @change="isUsingDeliveryLog" />
                  <label class="switch" for="bonus"></label>
                </div>
              </div>
              <div v-if="isUsingBonus" class="search-component">
                <p class="col-title">Бонусная группа</p>
                <v-autocomplete v-model="restaurantBonusGroupId" placeholder="---" :items="bonusGroups" item-text="name"
                  item-value="id" hide-details solo class="input-css">
                  <template v-slot:item="{ item, isSelected }">
                    <div :class="['restaurant-item', { 'active': isSelected }]">
                      {{ item.name }}
                    </div>
                  </template>
                </v-autocomplete>
              </div>
              <div class="col-content rest-name-container">
                <p class="col-title">Широта <span class="red-dot">*</span></p>
                <input type="number" class="input-css" v-model="latitude" placeholder="---" @input="onInputChange">
              </div>
              <div class="col-content rest-name-container">
                <p class="col-title">Долгота <span class="red-dot">*</span></p>
                <input type="number" class="input-css" v-model="longitude" placeholder="---" @input="onInputChange">
              </div>
              <div class="col-content rest-name-container mb-4">
                  <p class="col-title">Дата запуска<span class="red-dot">*</span></p>
                  
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div 
                        class="input-css custom-date-input" 
                        v-bind="attrs" 
                        v-on="on"
                      >
                        <span :class="{'placeholder-text': !resReleaseDate}">
                          {{ resReleaseDate ? formatDisplayDate(resReleaseDate) : '---' }}
                        </span>
                        <v-icon сlass="mt-0">mdi-calendar</v-icon>
                      </div>
                    </template>

                    <v-date-picker
                      v-model="resReleaseDate"
                      @input="dateMenu = false"
                      color="#323C4D"
                      locale="ru-ru"
                      first-day-of-week="1"
                    ></v-date-picker>
                  </v-menu>
                </div>

              <!-- <div class="search-component">
                <p class="col-title">Статус ресторана</p>
                <v-autocomplete v-model="restState" placeholder="---" :items="['Active', 'Inactive', 'Disabled']"
                  hide-details solo id="stateCode-selector" class="input-css" @change="onChangeState">
                  <template v-slot:item="{ item, isSelected }">
                    <div :class="['restaurant-item', { 'active': isSelected }]">
                      {{ item }}
                    </div>
                  </template>
                </v-autocomplete>
              </div> -->



            </div>
          </div>



          <div class="img-content-container">
            <div class="box-container ">
              <div>
                <h2 class="information-title">Логотип, картинка</h2>
                <div class="horizontal-line"></div>
                <div class="logo-flex">
                  <div class="d-flex">
                    <p class="mb-0 logo-dot">Логотип для светлой темы</p>
                  </div>
                  <div class="d-flex align-center">
                    <div v-if="uploadedImages['logoId']" class="uploaded-image-container">
                      <img :src="uploadedImages['logoId']" alt="Uploaded Image" class="uploaded-image-logo" />
                    </div>
                    <input type="file" accept="image/*" id="img-input-1" @change="(e) => handleImageUpload('logoId', e)"
                      style="display: none" />
                    <label for="img-input-1" class="custom-file-upload">
                      <img src="../assets/img/input-logo.svg" alt="" />
                    </label>
                  </div>
                </div>
              </div>


              <div class="horizontal-line"></div>
              <div class="logo-flex">
                <div class="d-flex">
                  <p class="mb-0 logo-dot">Логотип для темной темы</p>
                </div>
                <div class="d-flex align-center">
                  <div v-if="uploadedImages['logoDarkId']" class="uploaded-image-container preview-dark">
                    <img :src="uploadedImages['logoDarkId']" alt="Uploaded Image" class="uploaded-image-logo" />
                  </div>
                  <input type="file" accept="image/*" id="img-input-2"
                    @change="(e) => handleImageUpload('logoDarkId', e)" style="display: none" />
                  <label for="img-input-2" class="custom-file-upload">
                    <img src="../assets/img/input-logo.svg" alt="" />
                  </label>
                </div>
              </div>
              <div class="horizontal-line"></div>
              <div class="logo-flex">
                <div class="d-flex">
                  <p class="mb-0 logo-dot">Хедер для светлой темы</p>
                </div>
                <div class="d-flex align-center">
                  <div v-if="uploadedImages['headerLogoId']" class="uploaded-image-container">
                    <img :src="uploadedImages['headerLogoId']" alt="Uploaded Image" class="uploaded-image-logo" />
                  </div>
                  <input type="file" accept="image/*" id="img-input-3"
                    @change="(e) => handleImageUpload('headerLogoId', e)" style="display: none" />
                  <label for="img-input-3" class="custom-file-upload">
                    <img src="../assets/img/input-logo.svg" alt="" />
                  </label>
                </div>
              </div>
              <div class="horizontal-line"></div>
              <div class="logo-flex">
                <div class="d-flex">
                  <p class="mb-0 logo-dot">Хедер для темной темы</p>
                </div>
                <div class="d-flex align-center">
                  <div v-if="uploadedImages['headerLogoDarkId']" class="uploaded-image-container preview-dark">
                    <img :src="uploadedImages['headerLogoDarkId']" alt="Uploaded Image" class="uploaded-image-logo" />
                  </div>
                  <input type="file" accept="image/*" id="img-input-4"
                    @change="(e) => handleImageUpload('headerLogoDarkId', e)" style="display: none" />
                  <label for="img-input-4" class="custom-file-upload">
                    <img src="../assets/img/input-logo.svg" alt="" />
                  </label>
                </div>
              </div>
              <div class="horizontal-line"></div>
              <div class="logo-flex">
                <div class="d-flex">
                  <p class="mb-0 logo-dot">Фото ресторана</p>
                </div>
                <div class="d-flex align-center">
                  <div v-if="uploadedImages['backgroundImageId']" class="uploaded-image-container">
                    <img :src="uploadedImages['backgroundImageId']" alt="Uploaded Image" class="uploaded-image-logo" />
                  </div>
                  <input type="file" accept="image/*" id="img-input-5"
                    @change="(e) => handleImageUpload('backgroundImageId', e)" style="display: none" />
                  <label for="img-input-5" class="custom-file-upload">
                    <img src="../assets/img/input-logo.svg" alt="" />
                  </label>
                </div>
              </div>
              <div class="horizontal-line"></div>

            </div>
            <div class="box-container mt-5">
              <div>
                <div class="d-flex align-center justify-space-between">
                  <h2 class="information-title">Режим работы</h2>
                  <button @click="createWorkTime" class="btn-qr">
                    Настроить
                  </button>
                </div>

                <div class="horizontal-line"></div>
                <div v-if="!hasTimeTable" class="logo-flex">
                  <div class="d-flex">
                    <p class="mb-0 logo-dot">
                      У ресторана не выбран режим работы, чтобы настроить нажмите кнопку "Настроить"
                    </p>
                  </div>
                </div>
                <div v-else-if="restaurant.timeTable.type === 'Everyday'" class="mt-3">
                  <div class="my-3">
                    <p class="delivery-title">Все дни недели</p>
                    <p class="delivery-text">
                      {{ restaurant.timeTable.type === 'Everyday' ? "Используется" : "Не используется" }}
                    </p>
                  </div>
                  <div class="horizontal-line"></div>
                  <div class="mt-3">
                    <p class="day-name">Режим работы</p>

                    <p class="worktime-value">
                      с {{ formatApiTime(restaurant.timeTable.hoursGeneral.openingTime) }}
                      до
                      {{ formatApiTime(restaurant.timeTable.hoursGeneral.closingTime) }}
                    </p>
                  </div>

                </div>
                <div v-if="restaurant.timeTable.type === 'Weekly'">
                  <div class="my-3">
                    <p class="delivery-title">Выборочно</p>
                    <p class="delivery-text">
                      {{ restaurant.timeTable.type === 'Weekly' ? "Используется" : "Не используется" }}
                    </p>
                  </div>
                  <div class="horizontal-line"></div>

                  <div class="week-grid mt-3">
                    <div v-for="(item, index) in weeklyTable" :key="index" class="week-item">

                      <p class="day-name">{{ item.name }}</p>

                      <p v-if="item.isEnabled" class="day-time">
                        с {{ item.start }} до {{ item.end }}
                      </p>

                      <p v-else class="day-time disabled">выходной</p>

                    </div>
                  </div>
                </div>
                <v-dialog v-model="dialogWorkTime" max-width="537px" @input="onDialogWorkTimeInput">
                  <v-card class="modal-card">
                    <v-card-title class="modal-title">
                      {{ isEditing ? "Редактирование режима работы" : "Настройка режима работы" }}
                      <v-spacer></v-spacer>
                      <v-btn icon @click="closeDialogWorkTime">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <div class="card-item">
                        <div class="col-content">
                          <p class="col-title-work-time">Режим работы</p>

                        </div>
                        <div class="horizontal-line"></div>

                        <div class="col-content">
                          <div class="d-flex align-center justify-space-between mt-5">
                            <div class="">
                              <p class="delivery-title">Все дни недели</p>
                              <p class="delivery-text">{{
                                modalTimeData.isUsingAllDays ? "Используется" : "Не используется"
                              }}</p>
                            </div>

                            <div class="d-flex align-center">


                              <div class="">
                                <input type="checkbox" hidden="hidden" id="allDayWork"
                                  v-model="modalTimeData.isUsingAllDays" />
                                <!-- НАДО ПОТОМ ПОПРАВИТЬ <input type="checkbox" hidden="hidden" id="allDayWork" v-model="isUsingAllDays"
                                @change="isUsingAllDaysLog" /> -->
                                <label class="switch" for="allDayWork"></label>
                              </div>
                            </div>

                          </div>


                          <div v-if="modalTimeData.isUsingAllDays">
                            <p class="gray-text mt-5">Выберите время начала , и конец рабочего дня</p>

                            <div class="d-flex align-center justify-content-start time-row">
                              <div>
                                <p class="col-title">Время начала</p>
                                <input class="input-css input-css-time" v-model="modalTimeData.allDayWorkStart"
                                  @input="formatTime('allDayWorkStart', $event)" placeholder="--:--" />
                              </div>
                              <div>
                                <p class="col-title">Время окончания</p>
                                <input class="input-css input-css-time" v-model="modalTimeData.allDayWorkEnd"
                                  @input="formatTime('allDayWorkEnd', $event)" placeholder="--:--" />
                              </div>

                            </div>


                          </div>

                          <div class="horizontal-line mt-5"></div>
                        </div>

                        <div class="col-content">
                          <div class="d-flex align-center justify-space-between mt-5">
                            <div class="">
                              <p class="delivery-title">Выборочно</p>
                              <p class="delivery-text">{{
                                modalTimeData.isUsingTargetDays ? "Используется" : "Не используется"
                              }}</p>
                            </div>

                            <div class="d-flex align-center">


                              <div class="">
                                <input type="checkbox" hidden="hidden" id="TargetDays"
                                  v-model="modalTimeData.isUsingTargetDays" />
                                <!-- НАДО ПОТОМ ПОПРАВИТЬ <input type="checkbox" hidden="hidden" id="allDayWork" v-model="isUsingAllDays"
                                @change="isisUsingTargetDayssLog" /> -->
                                <label class="switch" for="TargetDays"></label>
                              </div>
                            </div>

                          </div>


                          <div v-if="modalTimeData.isUsingTargetDays">
                            <p class="gray-text mt-5">Выберите для каждого дня недели время начала, и конец рабочего дня
                            </p>

                            <div class="d-flex align-center justify-space-between py-2" v-for="(day, index) in weekDays"
                              :key="index">
                              <div>
                                <p class="col-title">День недели</p>
                                <input class="input-css-target input-css-target-time" :value="day.name" disabled />
                              </div>

                              <div>
                                <p class="col-title">Время начала</p>
                                <input class="input-css input-css-time" v-model="day.start"
                                  @input="formatTimeDynamic(index, 'start', $event)" placeholder="--:--" />
                              </div>

                              <div>
                                <p class="col-title">Время окончания</p>
                                <input class="input-css input-css-time" v-model="day.end"
                                  @input="formatTimeDynamic(index, 'end', $event)" placeholder="--:--" />
                              </div>
                              <div>
                                <input type="checkbox" hidden :id="'daySwitch' + index" v-model="day.isEnabled" />
                                <label class="switch" :for="'daySwitch' + index"></label>
                              </div>
                            </div>


                          </div>

                          <div class="horizontal-line mt-5"></div>
                        </div>

                      </div>
                    </v-card-text>
                    <div class="btn-container">
                      <div class="cancel-btn" text @click="closeDialogWorkTime">
                        Отменить
                      </div>

                      <div class="save-btn" text @click="confirmWorkTime">
                        Сохранить
                      </div>
                    </div>
                  </v-card>
                </v-dialog>
              </div>
            </div>

            <div class="box-container mt-5">
              <div>
                <div class="d-flex align-center justify-space-between">
                  <h2 class="information-title">Режим работы доставки</h2>
                  <button @click="createDeliveryTime" class="btn-qr">
                    Настроить
                  </button>
                </div>

                <div class="horizontal-line"></div>
                <div v-if="!hasTimeTableDelivery" class="logo-flex">
                  <div class="d-flex">
                    <p class="mb-0 logo-dot">
                      У ресторана не выбран режим работы доставки, чтобы настроить нажмите кнопку "Настроить"
                    </p>
                  </div>
                </div>
                <div v-else-if="restaurant.restaurantDelivery.timeTable.type === 'Everyday'" class="mt-3">
                  <div class="my-3">
                    <p class="delivery-title">Все дни недели</p>
                    <p class="delivery-text">
                      {{ restaurant.restaurantDelivery.timeTable.type === 'Everyday' ? "Используется" : "Неиспользуется"
                      }}
                    </p>
                  </div>
                  <div class="horizontal-line"></div>
                  <div class="mt-3">
                    <p class="day-name">Режим работы</p>

                    <p class="worktime-value">
                      с {{ formatApiTime(restaurant.restaurantDelivery.timeTable.hoursGeneral.openingTime) }}
                      до
                      {{ formatApiTime(restaurant.restaurantDelivery.timeTable.hoursGeneral.closingTime) }}
                    </p>
                  </div>

                </div>
                <div v-if="restaurant.restaurantDelivery.timeTable.type === 'Weekly'">
                  <div class="my-3">
                    <p class="delivery-title">Выборочно</p>
                    <p class="delivery-text">
                      {{ restaurant.restaurantDelivery.timeTable.type === 'Weekly' ? "Используется" : "Не используется"
                      }}
                    </p>
                  </div>
                  <div class="horizontal-line"></div>

                  <div class="week-grid mt-3">
                    <div v-for="(item, index) in weeklyTableDelivery" :key="index" class="week-item">

                      <p class="day-name">{{ item.name }}</p>

                      <p v-if="item.isEnabled" class="day-time">
                        с {{ item.start }} до {{ item.end }}
                      </p>

                      <p v-else class="day-time disabled">выходной</p>

                    </div>
                  </div>
                </div>
                <v-dialog v-model="dialogWorkTimeDelivery" max-width="560px" @input="onDialogWorkTimeInputDelivery">
                  <v-card class="modal-card">
                    <v-card-title class="modal-title">
                      {{ isEditing ? "Редактирование режима работы доставки" : "Настройка режима работы доставки" }}
                      <v-spacer></v-spacer>
                      <v-btn icon @click="closeDialogWorkTimeDelivery">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <div class="card-item">
                        <div class="col-content">
                          <p class="col-title-work-time">Режим работы доставки</p>

                        </div>
                        <div class="horizontal-line"></div>

                        <div class="col-content">
                          <div class="d-flex align-center justify-space-between mt-5">
                            <div class="">
                              <p class="delivery-title">Все дни недели</p>
                              <p class="delivery-text">{{
                                modalTimeDataDelivery.isUsingAllDaysDelivery ? "Используется" : "Не используется"
                              }}</p>
                            </div>

                            <div class="d-flex align-center">


                              <div class="">
                                <input type="checkbox" hidden="hidden" id="allDayWorkDelivery"
                                  v-model="modalTimeDataDelivery.isUsingAllDaysDelivery" />
                                <!-- НАДО ПОТОМ ПОПРАВИТЬ <input type="checkbox" hidden="hidden" id="allDayWork" v-model="isUsingAllDays"
                                @change="isUsingAllDaysLog" /> -->
                                <label class="switch" for="allDayWorkDelivery"></label>
                              </div>
                            </div>

                          </div>


                          <div v-if="modalTimeDataDelivery.isUsingAllDaysDelivery">
                            <p class="gray-text mt-5">Выберите время работы доставки</p>

                            <div class="d-flex align-center justify-content-start time-row">
                              <div>
                                <p class="col-title">Время начала</p>
                                <input class="input-css input-css-time"
                                  v-model="modalTimeDataDelivery.allDayWorkStartDelivery"
                                  @input="formatTimeDelivery('allDayWorkStartDelivery', $event)" placeholder="--:--" />
                              </div>
                              <div>
                                <p class="col-title">Время окончания</p>
                                <input class="input-css input-css-time"
                                  v-model="modalTimeDataDelivery.allDayWorkEndDelivery"
                                  @input="formatTimeDelivery('allDayWorkEndDelivery', $event)" placeholder="--:--" />
                              </div>

                            </div>


                          </div>

                          <div class="horizontal-line mt-5"></div>
                        </div>

                        <div class="col-content">
                          <div class="d-flex align-center justify-space-between mt-5">
                            <div class="">
                              <p class="delivery-title">Выборочно</p>
                              <p class="delivery-text">{{
                                modalTimeDataDelivery.isUsingTargetDaysDelivery ? "Используется" : "Не используется"
                              }}</p>
                            </div>

                            <div class="d-flex align-center">


                              <div class="">
                                <input type="checkbox" hidden="hidden" id="TargetDaysDelivery"
                                  v-model="modalTimeDataDelivery.isUsingTargetDaysDelivery" />
                                <!-- НАДО ПОТОМ ПОПРАВИТЬ <input type="checkbox" hidden="hidden" id="allDayWork" v-model="isUsingAllDays"
                                @change="isisUsingTargetDayssLog" /> -->
                                <label class="switch" for="TargetDaysDelivery"></label>
                              </div>
                            </div>

                          </div>


                          <div v-if="modalTimeDataDelivery.isUsingTargetDaysDelivery">
                            <p class="gray-text mt-5">Выберите для каждого дня недели время начала, и конец доставки
                            </p>

                            <div class="d-flex align-center justify-space-between py-2"
                              v-for="(day, index) in weekDaysDelivery" :key="index">
                              <div>
                                <p class="col-title">День недели</p>
                                <input class="input-css-target input-css-target-time" :value="day.name" disabled />
                              </div>

                              <div>
                                <p class="col-title">Время начала</p>
                                <input class="input-css input-css-time" v-model="day.start"
                                  @input="formatTimeDynamicDelivery(index, 'start', $event)" placeholder="--:--" />
                              </div>

                              <div>
                                <p class="col-title">Время окончания</p>
                                <input class="input-css input-css-time" v-model="day.end"
                                  @input="formatTimeDynamicDelivery(index, 'end', $event)" placeholder="--:--" />
                              </div>
                              <div>
                                <input type="checkbox" hidden :id="'daySwitch' + index" v-model="day.isEnabled" />
                                <label class="switch" :for="'daySwitch' + index"></label>
                              </div>
                            </div>


                          </div>

                          <div class="horizontal-line mt-5"></div>
                        </div>

                      </div>
                    </v-card-text>
                    <div class="btn-container">
                      <div class="cancel-btn" text @click="closeDialogWorkTimeDelivery">
                        Отменить
                      </div>

                      <div class="save-btn" text @click="confirmWorkTimeDelivery">
                        Сохранить
                      </div>
                    </div>
                  </v-card>
                </v-dialog>
              </div>
            </div>
          </div>



          <div class="communication-content-container">
            <div class="box-container">
              <div class="d-flex align-center justify-space-between">
                <h2 class="information-title">Коммуникации ресторана</h2>
                <button @click="createCommunication" class="btn-qr">
                  Создать
                  <!-- <img class="save-icon" src="../assets/icons/qr 1.svg" alt="app_qr" /> -->
                </button>
              </div>
              <div class="horizontal-line"></div>
              <div v-if="sortedCommunications.length > 0">
                <v-list two-line class="scrollable-list">
                  <v-list-item v-for="(item, index) in sortedCommunications" :key="item.id || index">
                    <v-list-item-content>
                      <v-list-item-title class="cursor-pointer" @click="copyName(item.name)">
                        {{ truncate(item.name, 50) }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Канал: {{ communicationChanelTypesTranslation[item.channelType] || item.channelType }} |
                        Приложение: {{ communicationTypesTranslation[item.type] || item.type }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <div class="btn-container-communication">
                      <button @click="editCommunicationModal(item)">
                        <img class="save-icon" src="../assets/icons/edit.svg" alt="" />
                      </button>
                      <button @click="deleteCommunicationModal(item)"> <img class="save-icon"
                          src="../assets/icons/gray-delete.svg" alt="" />
                      </button>


                    </div>
                  </v-list-item>
                </v-list>
              </div>
              <div v-else class="no-communications">
                <p class="">Коммуникации отсутствуют</p>
              </div>
            </div>
          </div>
        </div>
        <v-dialog v-model="dialogCreate" max-width="537px">
          <v-card class="modal-card">
            <v-card-title class="modal-title">
              {{ isEditing ? "Редактирование коммуникации" : "Создание коммуникации" }}
              <v-spacer></v-spacer>
              <v-btn icon @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <div class="card-item">

                <div class="col-content rest-name-container">
                  <p class="col-title">Значение коммуникации <span class="red-dot">*</span></p>
                  <input class="input-css" v-model="nameCommunication" placeholder="---">
                </div>
                <div class="col-content">
                  <p class="col-title">Приложение <span class="red-dot">*</span></p>
                  <v-autocomplete v-model="communicationType" placeholder="---" :items="translatedCommunicationTypes"
                    item-text="label" item-value="value" hide-details solo id="communicationType-selector"
                    class="input-css" @change="logCommunicationType">
                    <template v-slot:item="{ item, isSelected }">
                      <div :class="['restaurant-item', { 'active': isSelected }]">
                        {{ communicationTypeTranslation(item.label) }}
                      </div>
                    </template>
                  </v-autocomplete>
                </div>

                <div class="col-content">
                  <p class="col-title">Каналы <span class="red-dot">*</span></p>
                  <v-autocomplete v-model="communicationChanelType" placeholder="---"
                    :items="translatedCommunicationChanelTypes" item-text="label" item-value="value" hide-details solo
                    id="communicationChanelType-selector" class="input-css">
                    <template v-slot:item="{ item, isSelected }">
                      <div :class="['restaurant-item', { 'active': isSelected }]">
                        {{ communicationChanelTypeTranslation(item.label) }}
                      </div>
                    </template>
                  </v-autocomplete>
                </div>


              </div>
            </v-card-text>
            <div class="btn-container">
              <div class="cancel-btn" text @click="closeCreate">
                Отменить
              </div>

              <div class="save-btn" text @click="handleButtonClick">
                Сохранить
              </div>
            </div>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="431px">
          <div>
            <div class="modal-container">
              <p class="modal-text">Вы точно хотите удалить данную коммуникацию?</p>
              <div class="btn-modal-container">
                <div class="cancel-btn" text @click="closeDelete">
                  Отмена
                </div>
                <div class="del-btn" text @click="deleteCommunication">
                  Удалить
                </div>
              </div>
            </div>

          </div>

        </v-dialog>
        <v-snackbar v-model="snackbar" timeout="3000" class="btn-contaiener">
          {{ message }}
          <template v-slot:action="{ attrs }">
            <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
              Закрыть
            </div>
          </template>
        </v-snackbar>
      </template>
    </div>
  </div>
</template>


<style scoped>
.custom-date-input {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  background-color: #fff;
  /* Добавьте padding, если в вашем .input-css его нет */
  padding: 0 12px; 
}
.worktime-value {
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: Inter;
  color: #606c80;
  font-size: 15px;
  font-weight: 400;
}

.week-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 30px;
  row-gap: 10px;
}

.week-item {
  display: flex;
  flex-direction: column;
}

.day-name {
  font-weight: 600;
  margin-bottom: 0px;
  font-family: Inter;
  color: #323c4d;
}

.day-time {
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: Inter;
  color: #606c80;
  font-size: 15px;
  font-weight: 400;
}

.day-time.disabled {
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: Inter;
  color: #606c80;
  font-size: 15px;
  font-weight: 400;
}

.time-row {
  display: flex;
  gap: 19px;
}

.input-css-target-time {
  width: 100px;
  text-align: left;
}

.input-css-time {
  width: 70px;
  text-align: center;
}

.gray-text {
  font-family: Inter;
  font-weight: 400;
  font-size: 15px;
  color: #98a2b2;
}

.no-communications p {
  color: #606c80;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  margin-bottom: 0px;
  padding: 24px 0;
}

.del-btn {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 8px;
  background: #e41313;
  display: inline-flex;
  padding: 13px 29px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

::v-deep .v-dialog {
  /* border-radius: 20px; */
  background: #F8F8F8;
  margin: 24px;
  overflow-y: auto;
  pointer-events: auto;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  width: 100%;
  z-index: inherit;
  box-shadow: none;
}

.btn-modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 36.7px;
}

.modal-text {
  font-family: Inter;
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  color: #323c4d;
  margin-bottom: 0px;
  line-height: normal;
}

.modal-container {
  padding: 20px 20px 37px 20px;
}

.btn-container-communication {
  display: flex;
  align-items: center;
}

.scrollable-list {
  overflow: auto;
  max-height: 475px;
}

.cursor-pointer {
  cursor: pointer;
}

.card-item {
  background: #fff;
  /* max-width: 247px; */
  /* width: px; */
  border-radius: 5px;
  /* height: 620px; */
  display: flex;
  flex-direction: column;
  padding: 18px 18px 23px 18px;
}

.modal-card {
  background-color: #F8F8F8 !important;
}

.modal-title {
  color: var(--gray-1, #333);
  font-family: Inter !important;
  font-size: 24px !important;
  font-style: normal;
  font-weight: 600 !important;
  line-height: normal;
}

.save-btn {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 8px;
  background: #323C4D;
  display: inline-flex;
  padding: 13px 29px;
  justify-content: center;
  align-items: center;
  gap: 32.5px;
  cursor: pointer;
}

.cancel-btn {
  color: #eb5757;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 8px;
  display: inline-flex;
  padding: 13px 29px;
  cursor: pointer;

}

.btn-container {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 46px;
  align-items: center;
  padding-right: 20px;
}

.header-desktop-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

input[type="number"] {
  -moz-appearance: textfield;
  /* Убирает стрелочки в Firefox */
  -webkit-appearance: none;
  /* Убирает стрелочки в Chrome, Safari */
  appearance: none;
  /* Для совместимости */
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  /* Убирает стрелочки в Chrome, Safari */
  margin: 0;
  /* Убирает лишние отступы */
}

.snackbar-btn {
  color: var(--Red, #eb5757);
  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  line-height: 1.25rem;
  margin-right: auto;
  padding: 14px 16px;
  text-align: initial;
  cursor: pointer;
}

.red-border {
  border: 1px solid red !important;
}

.restaurant-item {
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

::v-deep .v-autocomplete__content.v-menu__content {
  color: #000;
  background-color: #000;
  background: #000;
}

::v-deep .v-autocomplete__content .v-list-item__title {
  color: black;
  /* Цвет текста */
}

::v-deep .v-autocomplete__content.v-menu__content {
  color: #000;
  background-color: #000;
  background: #000;
}

::v-deep .v-autocomplete.v-input--outlined .v-input__control {
  border: none !important;
}

::v-deep .v-autocomplete__content.v-menu__content .v-select-list {
  border-radius: 0 0 4px 4px;
  background: green;
}

::v-deep .v-autocomplete__content input {
  border: 1px solid rgb(224, 224, 224);
  border-radius: 5px;
  width: 100%;
  outline: unset;
  padding: 0 40px 0 15px;
  display: flex;
  align-items: center;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none !important;
  /* border: 1px solid rgb(224, 224, 224); */
}

::v-deep .v-text-field--outlined fieldset {
  border: none !important;
}

.restaurant-item {
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.restaurant-item :first-child {
  /* padding-left: 10px; */
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: #000 !important;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
  width: 100%;
  border-bottom: 0.5px solid rgb(212, 212, 225);
}

.communication-content-container {
  border-radius: 8px;
  background: var(--white, #fff);
  width: 100%;
  max-width: 533px;
  height: 100%;
  margin-top: 16px;
}

.img-content-container {
  border-radius: 8px;

  width: 100%;
  max-width: 533px;
  height: 100%;
  margin-top: 16px;
}

.container-main {
  display: flex;
  gap: 26px;
  /* flex-wrap: wrap; */
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none !important;
  border: 1px solid transparent !important;
}

.deliverty-title-margin {
  margin-top: 29.5px;
}

.loyal-margin {
  margin-top: 29.5px;
}

.delivery-text {
  font-family: Inter;
  font-weight: 400;
  font-size: 15px;
  color: #606c80;
  margin-bottom: 0px;
}

.delivery-title {
  margin-bottom: 0px;
  font-family: Inter;
  font-weight: 600;
  font-size: 15px;
  color: #323c4d;
}

.switch {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 25px;
  border-radius: 20px;
  background: #eaeaea;
  transition: background 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  vertical-align: middle;
  cursor: pointer;
}

.switch::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: #fafafa;
  border-radius: 50%;
  transition: left 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    background 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.switch:active::before {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28), 0 0 0 20px rgba(128, 128, 128, 0.1);
}

input:checked+.switch {
  background: #72da67;
}

input:checked+.switch::before {
  left: 27px;
  background: #fff;
}

input:checked+.switch:active::before {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28), 0 0 0 20px rgba(0, 150, 136, 0.2);
}

.minorder-container {
  margin-top: 23.5px;
}

.adress-container {
  margin-top: 23.5px;
}

.phonenumber-container {
  margin-top: 23.5px;
}

.search-component {
  margin-top: 11.5px;
}

.input-css {
  border-radius: 5px;
  padding: 10px 10px 10px 10px;
  /* height: 42px; */
  border: 1px solid transparent;
  outline: none;
  transition: border 0.3s ease;
  font-family: Inter;
  font-weight: 600;
  font-size: 15px;
  color: #323c4d;

}

.input-css-target {

  border-radius: 5px;
  padding: 10px 0px;
  border: none !important;
  outline: none !important;
  font-family: Inter;
  font-weight: 600;
  font-size: 15px;
  color: #323c4d;

}

/* Убираем hover */
.input-css-target:hover {
  border: none !important;
  outline: none !important;
  cursor: default;
}

/* Убираем рамку при фокусе */
.input-css-target:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.input-css-textarea {
  border-radius: 5px;
  padding: 10px 10px 10px 10px;
  height: 72px;
  border: 1px solid transparent;
  outline: none;
  transition: border 0.3s ease;
  font-family: Inter;
  font-weight: 600;
  font-size: 15px;
  color: #323c4d;
  resize: none;
}

.input-css-textarea:hover,
.input-css-textarea:focus {
  border: 1px solid #d4d4e1;
  /* Цвет бордера при наведении */
}

.input-css:hover,
.input-css:focus {
  border: 1px solid #d4d4e1;

}

.desc-rest-container {
  margin-top: 14px;
}

.rest-name-container {
  margin-top: 17px;
}

.box-container {
  padding: 18px 18px;
  background: var(--white, #fff);
}

.special-border:focus {
  border-radius: 3px;
  border: 1px solid var(--03, #c1c1c1);
  background: var(--white, #fff);
  width: 295px;
  height: 37px;
  padding-left: 10px;
}

.special-border {
  border-radius: 3px;
  border: 1px solid var(--03, #c1c1c1);
  background: var(--white, #fff);
  width: 295px;
  height: 37px;
  padding-left: 10px;
}

textarea::-webkit-scrollbar {
  width: 5px;
  /* ширина полосы прокрутки */
}

textarea::-webkit-scrollbar-thumb {
  background-color: #888;
  /* цвет полосы прокрутки */
  border-radius: 2px;
  /* закругление углов полосы прокрутки */
}

textarea::-webkit-scrollbar-track {
  background-color: #f2f2f2;
  /* цвет фона дорожки полосы прокрутки */
}

input:focus {
  box-sizing: border-box;
  border: 1px solid rgb(212, 212, 225);
  border-radius: 5px;
  background: rgb(255, 255, 255);
}

input:hover {
  box-sizing: border-box;
  border: 1px solid rgb(212, 212, 225);
  border-radius: 5px;
  background: rgb(255, 255, 255);
  cursor: pointer;
}

.full-text-input,
:focus {
  outline: none;
  /* Убираем внешний контур (outline) при фокусе */
  border: none;
  /* Убираем границу (border) при фокусе */
  box-shadow: none;
  /* Убираем тень (box-shadow) при фокусе */
}

textarea:focus {
  box-sizing: border-box;
  border: 1px solid rgb(212, 212, 225);
  border-radius: 5px;
  background: rgb(255, 255, 255);
}

textarea:hover {
  box-sizing: border-box;
  border: 1px solid rgb(212, 212, 225);
  border-radius: 5px;
  background: rgb(255, 255, 255);
  cursor: pointer;
}

.border-textarea {
  box-sizing: border-box;
  border: 1px solid rgb(212, 212, 225);
  border-radius: 5px;
  background: rgb(255, 255, 255);
}

.switch {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 25px;
  border-radius: 20px;
  background: #eaeaea;
  transition: background 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  vertical-align: middle;
  cursor: pointer;
}

.switch::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: #fafafa;
  border-radius: 50%;
  transition: left 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    background 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.switch:active::before {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28), 0 0 0 20px rgba(128, 128, 128, 0.1);
}

input:checked+.switch {
  background: #72da67;
}

input:checked+.switch::before {
  left: 27px;
  background: #fff;
}

input:checked+.switch:active::before {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28), 0 0 0 20px rgba(0, 150, 136, 0.2);
}

.information-text {
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0%;
  text-align: left;
  margin-bottom: 0px;
}

.information-title-text {
  color: rgb(50, 60, 77);
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0%;
  text-align: left;
  margin-bottom: 0px;
}

.information-title-text-special {
  color: rgb(50, 60, 77);
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0%;
  text-align: left;
}

.information-text-green {
  color: rgb(0, 184, 0);
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0%;
  text-align: left;
  margin-bottom: 0px;
}

.information-text-red {
  color: red;
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0%;
  text-align: left;
  margin-bottom: 0px;
}

.requisites-text-container {
  display: flex !important;
  flex-direction: row;
  /* justify-content: space-evenly; */
  align-items: baseline;
}

.requisites-title {
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.margin-logo-divider {
  margin-bottom: 48px;
}

.logo-dot-3 {
  margin-right: 13px;
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.logo-dot-2 {
  margin-right: 16px;
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.logo-dot {
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.custom-file-upload {
  cursor: pointer;
  margin-left: 15px;
  /* display: flex; */
}

.logo-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 17px;
}

.uploaded-image-logo {
  max-width: 100px;
  /* Adjust this value as needed */
  max-height: 100px;
  /* Adjust this value as needed */
  /* margin-right: 21px; */
  display: flex;
}

.preview-dark {
  background-image: linear-gradient(45deg, #ccc 25%, transparent 25%),
    linear-gradient(-45deg, #ccc 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #ccc 75%),
    linear-gradient(-45deg, transparent 75%, #ccc 75%);
  background-size: 700px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
  padding: 10px;
  border-radius: 8px;
}

.uploaded-image-header {
  max-width: 100px;
  /* Adjust this value as needed */
  max-height: 100px;
  /* Adjust this value as needed */
  margin-right: 21px;
}

.uploaded-image-photo-rest {
  max-width: 100px;
  /* Adjust this value as needed */
  max-height: 100px;
  /* Adjust this value as needed */
  margin-right: 21px;
}

.work-margin-img {
  margin-bottom: 15px;
}

.work-img {
  width: 22px;
  height: 22px;
}

.col-img {
  flex-direction: column-reverse;
  display: flex;
}

.work-margin {
  padding-bottom: 15px;
}


.horizontal-line {
  height: 1px;
  background: #d4d4e1;
  margin-top: 5px;

}

.tel-pointer {
  cursor: pointer;
}

.col-paddings-r-l {
  padding-right: 0px;
  padding-left: 0px;
}

.col-paddings-t-b {
  padding-top: 0px;
  padding-bottom: 0px;
}

.col-content {
  display: flex;
  flex-direction: column;
}

.col-description {
  color: rgb(50, 60, 77);
  font-family: Inter;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0%;
  text-align: left;
  margin-bottom: 0px;
  word-wrap: break-word;
  resize: none;
  min-height: 20px;
  /* Минимальная высота для textarea */
  padding: 10px;
}


.red-dot {
  color: #e41313;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.col-title-work-time {
  color: #323c4d;
  font-family: Inter;
  font-size: 20px;
  font-style: bold;
  font-weight: 700;
  line-height: normal;
  word-wrap: break-word;
  margin-bottom: 5px;
}

.col-title {
  color: #323c4d;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 10px;
  word-wrap: break-word;
}

.information-title {
  font-family: Inter;
  font-style: normal;
  line-height: normal;
  font-weight: 700;
  font-size: 20px;
  color: #323c4d;
}

.content-container {
  border-radius: 8px;
  background: var(--white, #fff);
  margin-top: 16px;
  width: 100%;
  max-width: 533px;

}

.container-margin {
  margin: auto;
}

.btn-container-communication button:first-child .save-icon {
  margin-right: 15px;
}

.save-icon {

  width: 18px;
  height: 18px;
}

.btn-save {
  width: 139px;
  height: 36px;
  left: 1750px;
  right: 31px;
  top: 86px;
  bottom: 958px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 18px 5px 18px;
  border-radius: 5px;
  background: rgb(50, 60, 77);
  color: white;
  margin-left: 20px;
}

.btn-qr {
  height: 36px;
  left: 1750px;
  right: 31px;
  top: 86px;
  bottom: 958px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 18px 5px 18px;
  border-radius: 5px;
  background: rgb(50, 60, 77);
  color: white;
  margin-left: 20px;
}

.warning-red {
  color: rgb(228, 19, 19);
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0%;
  text-align: left;
  margin-bottom: 0px;
}

::v-deep.v-tabs .v-tabs-bar .v-tabs-slider {
  background-color: #00b800 !important;
  /* Укажите желаемый цвет для индикатора */
}

::v-deep .v-tab:before {
  background-color: gray;
  bottom: 0;
  content: "";
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

::v-deep .theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-btn,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 1.1rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

::v-deep .v-tab {
  caret-color: #ff0000 !important;
  color: #333;
  align-items: center;
  cursor: pointer;
  display: flex;
  flex: 0 1 auto;
  font-size: 1.1rem;
  font-weight: 600;
  font-style: normal;
  justify-content: center;
  letter-spacing: normal;
  line-height: normal;
  min-width: 90px;
  max-width: 360px;
  outline: none;
  padding: 0 16px;
  position: relative;
  text-align: center;
  -webkit-text-decoration: none;
  text-decoration: none;
  text-transform: none;
  transition: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  font-family: "Inter";
}

.breadcrums-click {
  cursor: pointer;
}

.breadcrums-title {
  color: var(--02, #848484);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  text-decoration: none;
}

.breadcrums-container {
  display: flex;
  align-items: center;
  margin-top: 7px;
}

::v-deep .v-input__slot {
  border-style: none;
  margin-bottom: 0px;
}

.title-container {
  padding-left: 40px;
  padding-right: 30px;
  padding-top: 17px;
}

.title-container-tabs {
  padding-left: 40px;
  padding-right: 30px;
  padding-top: 0px;
}

.img-pluss-btn {
  cursor: pointer;
  height: 100%;
  display: flex;
  margin-right: 17px;

}

.arrow-btn {
  /* border-right: 1px solid var(--04, #eaeaea); */
  /* width: 56px; */
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
}

/* .top-panel .container {
    width: 100%;
    padding: 0px !important;
    margin-right: 0 !important;
    margin-left: 0 !important;
  } */
.vertical-line {
  width: 1px;
  height: 42px;
  background: #e0e0e0;
  margin-left: 31px;
}

.vertical-line-1 {
  width: 1px;
  height: 50px;
  background: #e0e0e0;
}

.add-btn .add-text {
  color: var(--01, #333);
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  margin-left: 12px;
  transition: color 0.3s ease;
}

.add-btn:hover .add-text {
  /* Цвет текста при наведении */
  color: black;
  /* Замените "red" на желаемый цвет текста */
  font-weight: 500;
  font-size: 17px;
}

.add-btn {
  display: flex;
  align-items: center;
  padding: 12px 0px;
  margin-left: 37px;
  cursor: pointer;
}

.top-panel {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media (max-width: 1069px) {
  .modal-title {
    color: #323c4d;
    font-family: Inter !important;
    font-size: 24px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: normal;
    word-break: auto-phrase;
  }

  .container-main {
    /* flex-direction: column; */
    flex-wrap: wrap;
    gap: 20px;
    /* Можем задать другой размер отступов, если нужно */
  }

  .content-container {
    border-radius: 8px;
    background: var(--white, #fff);
    margin-top: 16px;
    width: 100%;
    max-width: none;
    flex: 1 1 calc(33.333% - 26px);
  }

  .img-content-container {
    border-radius: 8px;

    width: 100%;
    max-width: none;
    height: 100%;
    margin-top: 16px;
    flex: 1 1 calc(33.333% - 26px);


  }

  .communication-content-container {
    border-radius: 8px;
    background: var(--white, #fff);
    width: 100%;
    max-width: 533px;
    height: 100%;
    margin-top: 16px;
    flex: 1 1 calc(33.333% - 26px);
  }
}

@media (max-width: 650px) {
  .header-desktop-container-mobile {
    display: flex;
    align-items: center;
    flex-direction: column;

  }

  .restaurant-title-adress {
    color: #323c4d;
    font-family: Inter;
    font-size: 19px;
    font-weight: 400;
    line-height: 29px;
    letter-spacing: 0%;
    text-align: left;
  }

  .btn-save {
    width: 139px;
    height: 36px;
    /* left: 1750px;
    right: 31px; */
    /* top: 86px;
    bottom: 958px; */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px 18px 5px 18px;
    border-radius: 5px;
    background: rgb(50, 60, 77);
    color: white;
    margin-left: 0px;
    margin-top: 10px;
  }

  .btn-qr {
    height: 36px;
    /* left: 1750px;
    right: 31px; */
    /* top: 86px;
    bottom: 958px; */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px 18px 5px 18px;
    border-radius: 5px;
    background: rgb(50, 60, 77);
    color: white;
    margin-left: 0px;
    margin-top: 10px;
  }

  .button-container {
    flex-wrap: wrap;
    gap: 5px 10px;
    justify-content: center;
  }

  .page-title {
    font-family: Inter;
    font-weight: 700;
    font-size: 19px;
    color: #323c4d;
    line-height: normal;
  }

  .nav-container {
    margin-top: 24px;
  }

  .container-main {
    flex-direction: column;
    /* Изменяем направление на колонку */
    gap: 20px;
    /* Можем задать другой размер отступов, если нужно */
  }

  .content-container {
    padding: 18px 18px;
    width: 100%;
    max-width: none;
  }
}
</style>




<script>
// import Cleave from 'vue-cleave-component';
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
//import Summary from "../components/productPageTabs/summary.vue";

export default {
  // components: { Summary },
  directives: { mask },
  name: "RestaurantPage",
  // components: {
  //   Cleave
  // },
  data() {
    return {
      initialLoaded: false,
      dateMenu: false,
      resReleaseDate: '',
      cleaveOptions: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        delimiter: " "
      },
      weekDays: [
        { name: "Понедельник", api: "Monday", start: "", end: "", isEnabled: false },
        { name: "Вторник", api: "Tuesday", start: "", end: "", isEnabled: false },
        { name: "Среда", api: "Wednesday", start: "", end: "", isEnabled: false },
        { name: "Четверг", api: "Thursday", start: "", end: "", isEnabled: false },
        { name: "Пятница", api: "Friday", start: "", end: "", isEnabled: false },
        { name: "Суббота", api: "Saturday", start: "", end: "", isEnabled: false },
        { name: "Воскресенье", api: "Sunday", start: "", end: "", isEnabled: false }
      ],
      originalWeekDays: [],
      weekDaysDelivery: [
        { name: "Понедельник", api: "Monday", start: "", end: "", isEnabled: false },
        { name: "Вторник", api: "Tuesday", start: "", end: "", isEnabled: false },
        { name: "Среда", api: "Wednesday", start: "", end: "", isEnabled: false },
        { name: "Четверг", api: "Thursday", start: "", end: "", isEnabled: false },
        { name: "Пятница", api: "Friday", start: "", end: "", isEnabled: false },
        { name: "Суббота", api: "Saturday", start: "", end: "", isEnabled: false },
        { name: "Воскресенье", api: "Sunday", start: "", end: "", isEnabled: false }
      ],
      originalWeekDaysDelivery: [],
      restaurant: {},
      // stateList: [
      //   { id: 'Active', stateCode: 'Активен' },
      //   { id: 'Inactive', stateCode: 'Неактивен' },
      //   { id: 'Disabled', stateCode: 'Отключен' }
      // ],
      // restState: null,
      allDayWorkEnd: "",
      allDayWorkStart: "",
      allDayWorkEndDelivery: "",
      allDayWorkStartDelivery: "",
      snackbar: false,
      dialogDelete: false,
      dialogCreate: false,
      dialogWorkTime: false,
      dialogWorkTimeDelivery: false,
      // Оригинальные данные (из API)
      originalTimeData: {
        isUsingAllDays: false,
        isUsingTargetDays: false,
        allDayWorkStart: "",
        allDayWorkEnd: "",
        // weekDays: []
      },
      modalTimeData: {
        isUsingAllDays: false,
        isUsingTargetDays: false,
        allDayWorkStart: "",
        allDayWorkEnd: "",
        // weekDays: []
      },
      originalTimeDataDelivery: {
        isUsingAllDaysDelivery: false,
        isUsingTargetDaysDelivery: false,
        allDayWorkStartDelivery: "",
        allDayWorkEndDelivery: "",
        // weekDays: []
      },
      modalTimeDataDelivery: {
        isUsingAllDaysDelivery: false,
        isUsingTargetDaysDelivery: false,
        allDayWorkStartDelivery: "",
        allDayWorkEndDelivery: "",
        // weekDays: []
      },
      isEditing: false,
      message: "",
      latitude: null,
      longitude: null,
      loading: false,
      dataChanged: false,
      originalData: {},
      selectedImage: null,
      uploadedImageLogoWhite: "",
      uploadedImageLogoDark: "",
      uploadedImageHeaderLogo: "",
      uploadedImageHeaderLogoDark: "",
      uploadedImageBackgroundImage: "",
      minOrder: "",
      name: "",
      address: "",
      description: "",
      minOrderAmount: null,
      phoneNumber: "",
      nameCommunication: "",
      communicationChanelType: "",
      communicationChanelTypes: [
        { label: 'WriteWhatsApp', value: 1 },
        { label: 'WriteTelegram', value: 3 },
        { label: 'WriteTelegramGroup', value: 5 },
        { label: 'TwoGisLink', value: 6 },
        { label: 'CallPhoneNumber', value: 7 },
        { label: 'FaceBookLink', value: 8 },
        { label: 'InstagramLink', value: 9 },
      ],
      communicationChanelTypesTranslation: {
        WriteWhatsApp: "Написать в WhatsApp",
        WriteTelegram: "Написать в Telegram",
        WriteTelegramGroup: "Написать в группу Telegram",
        TwoGisLink: "Ссылка на 2ГИС",
        CallPhoneNumber: "Позвонить",
        FaceBookLink: "Ссылка на Facebook",
        InstagramLink: "Ссылка на Instagram",
      },
      communicationType: "",
      communicationTypes: [
        { label: 'ContactRestaurant', value: 0 },
        { label: 'ContactSupport', value: 1 },
        { label: 'ReserveTable', value: 2 }
      ],
      communicationTypesTranslation: {
        ContactRestaurant: "Гостевое",
        ContactSupport: "Ресторанное",
        ReserveTable: "Бронирование стола",
      },
      selectedCommunication: null,
      // faceBookUrl: "",
      // twoGisUrl: "",
      // tgUrl: "",
      // whatsupUrl: "",
      // reservationUrl: "",
      isUsingDelivery: false,
      isUsingBonus: false,
      isUsingAllDays: false,
      isUsingTargetDays: false,
      accountId: "",
      applicationId: "",
      accounts: [],
      account: {},
      application: {},
      bonusGroups: {},
      restaurantBonusGroup: {},
      restaurantBonusGroupId: "",
      applications: [],
      currentImageId: "",
      previousImage: null,
      resImages: {
        headerLogoId: null,
        headerLogoDarkId: null,
        logoId: null,
        logoDarkId: null,
        backgroundImageId: null,
      },
      uploadedImages: {
        headerLogoId: null,
        headerLogoDarkId: null,
        logoId: null,
        logoDarkId: null,
        backgroundImageId: null,
      },
    };
  },
  watch: {
    "modalTimeData.isUsingAllDays"(val) {
      if (val) {
        this.modalTimeData.isUsingTargetDays = false;
      }
    },
    "modalTimeData.isUsingTargetDays"(val) {
      if (val) {
        this.modalTimeData.isUsingAllDays = false;
      }
    },
    "modalTimeDataDelivery.isUsingAllDaysDelivery"(val) {
      if (val) {
        this.modalTimeDataDelivery.isUsingTargetDaysDelivery = false;
      }
    },
    "modalTimeDataDelivery.isUsingTargetDaysDelivery"(val) {
      if (val) {
        this.modalTimeDataDelivery.isUsingAllDaysDelivery = false;
      }
    },
    nameCommunication(newVal) {
      console.log("nameCommunication изменилось:", newVal);
    },
    communicationType(newVal) {
      console.log("communicationType изменилось (value):", newVal);
      const label = this.communicationTypes.find(t => t.value === newVal)?.label;
      console.log("communicationType (label):", label);
    },
    communicationChanelType(newVal) {
      console.log("communicationChanelType изменилось (value):", newVal);
      const label = this.communicationChanelTypes.find(c => c.value === newVal)?.label;
      console.log("communicationChanelType (label):", label);
    },
    accountId(newVal) {
      if (newVal) {
        // когда пользователь выбрал accountId — грузим бонусные группы
        this.loadBonusGroups(newVal);
      } else {
        // если очистил выбор — блокируем поле и очищаем список
        this.bonusGroups = [];
        this.restaurantBonusGroupId = null;
      }
    }
  },
  methods: {
    onDialogWorkTimeInput(val) {
      if (!val) {
        // Модалка закрылась, сбросим все к оригиналу
        this.closeDialogWorkTime();
      }
    },
    onDialogWorkTimeInputDelivery(val) {
      if (!val) {
        // Модалка закрылась, сбросим все к оригиналу
        this.closeDialogWorkTimeDelivery();
      }
    },
    closeDialogWorkTime() {
      // Восстанавливаем состояние дней недели
      this.weekDays = this.originalWeekDays.map(day => ({ ...day }));

      // Восстанавливаем состояние выбора между «Все дни» и «Выбранные дни»
      this.modalTimeData.isUsingAllDays = this.originalTimeData.isUsingAllDays;
      this.modalTimeData.isUsingTargetDays = this.originalTimeData.isUsingTargetDays;

      // Если есть поля allDayWorkStart/end для everyday
      this.modalTimeData.allDayWorkStart = this.originalTimeData.allDayWorkStart;
      this.modalTimeData.allDayWorkEnd = this.originalTimeData.allDayWorkEnd;
      this.dialogWorkTime = false;


    },
    closeDialogWorkTimeDelivery() {
      // Восстанавливаем состояние дней недели
      this.weekDaysDelivery = this.originalWeekDaysDelivery.map(day => ({ ...day }));

      // Восстанавливаем состояние выбора между «Все дни» и «Выбранные дни»
      this.modalTimeDataDelivery.isUsingAllDaysDelivery = this.originalTimeDataDelivery.isUsingAllDaysDelivery;
      this.modalTimeDataDelivery.isUsingTargetDaysDelivery = this.originalTimeDataDelivery.isUsingTargetDaysDelivery;

      // Если есть поля allDayWorkStart/end для everyday
      this.modalTimeDataDelivery.allDayWorkStartDelivery = this.originalTimeDataDelivery.allDayWorkStartDelivery;
      this.modalTimeDataDelivery.allDayWorkEndDelivery = this.originalTimeDataDelivery.allDayWorkEndDelivery;
      this.dialogWorkTimeDelivery = false;


    },

    formatTimeDynamic(index, field, e) {
      let val = e.target.value.replace(/\D/g, "");

      if (val.length > 2) {
        val = val.slice(0, 2) + ":" + val.slice(2, 4);
      }

      val = val.slice(0, 5);

      // обновляем конкретный день
      this.weekDays[index][field] = val;
    },
    formatTimeDynamicDelivery(index, field, e) {
      let val = e.target.value.replace(/\D/g, "");

      if (val.length > 2) {
        val = val.slice(0, 2) + ":" + val.slice(2, 4);
      }

      val = val.slice(0, 5);

      // обновляем конкретный день
      this.weekDaysDelivery[index][field] = val;
    },
    formatTime(field, e) {
      let val = e.target.value.replace(/\D/g, "");

      if (val.length > 2) {
        val = val.slice(0, 2) + ":" + val.slice(2, 4);
      }

      this.modalTimeData[field] = val.slice(0, 5);
    },
    formatTimeDelivery(field, e) {
      let val = e.target.value.replace(/\D/g, "");

      if (val.length > 2) {
        val = val.slice(0, 2) + ":" + val.slice(2, 4);
      }

      this.modalTimeDataDelivery[field] = val.slice(0, 5);
    },
    editCommunicationModal(item) {
      this.isEditing = true;
      this.editingItem = item;

      this.nameCommunication = item.name;

      // Ищем по label или value (на случай разных форматов данных с бэка)
      const foundType = this.communicationTypes.find(
        t => t.label === item.type || t.value === item.type
      );
      const foundChannel = this.communicationChanelTypes.find(
        c => c.label === item.channelType || c.value === item.channelType
      );

      this.communicationType = foundType ? foundType.value : null;
      this.communicationChanelType = foundChannel ? foundChannel.value : null;

      // console.log("При открытии:");
      // console.log("nameCommunication:", this.nameCommunication);
      // console.log("communicationType value:", this.communicationType, "label:", foundType?.label);
      // console.log("communicationChanelType value:", this.communicationChanelType, "label:", foundChannel?.label);

      this.dialogCreate = true;
    },

    updateCommunication() {
      // console.log("Перед сохранением:");
      // console.log("nameCommunication:", this.nameCommunication);
      // console.log("communicationType:", this.communicationType);
      // console.log("communicationChanelType:", this.communicationChanelType);

      // Проверка: null или undefined, но ноль допускаем
      if (
        !this.nameCommunication ||
        this.communicationType === null || this.communicationType === undefined ||
        this.communicationChanelType === null || this.communicationChanelType === undefined
      ) {
        this.snackbar = true;
        this.message = "Пожалуйста, заполните все поля";
        return;
      }

      const selectedType = this.communicationTypes.find(t => t.value === this.communicationType);
      const selectedChannel = this.communicationChanelTypes.find(c => c.value === this.communicationChanelType);

      const updatedCommunication = {
        id: this.editingItem.id,
        name: this.nameCommunication,
        type: selectedType?.label || null,
        channelType: selectedChannel?.label || null
      };

      // console.log("Отправляем на бэк:", updatedCommunication);

      this.$http
        .put(`/api/RestaurantCommunication/${updatedCommunication.id}`, updatedCommunication)
        .then(() => {
          this.snackbar = true;
          this.message = "Коммуникация успешно обновлена";
          this.dialogCreate = false;
          this.isEditing = false;
          this.editingItem = null;

          this.getRestaurant();
        })
        .catch((error) => {
          this.snackbar = true;
          this.message = "Ошибка при обновлении коммуникации";
          console.error(error);
        });
    },
    truncate(text, length) {
      return text.length > length ? text.slice(0, length) + '…' : text;
    },
    copyName(name) {
      navigator.clipboard.writeText(name).then(() => {
        this.message = 'Текст скопирован';
        this.snackbar = true;
      }).catch(() => {
        this.message = 'Ошибка при копировании';
        this.snackbar = true;
      });
    },
    logCommunicationType(value) {
      console.log('Selected communicationType:', value);
    },
    communicationTypeTranslation(role) {
      return this.communicationTypesTranslation[role] || role;
    },
    communicationChanelTypeTranslation(role) {
      return this.communicationChanelTypesTranslation[role] || role;
    },
    deleteCommunication() {
      if (!this.selectedCommunication || !this.selectedCommunication.id) return;

      const id = this.selectedCommunication.id;

      this.$http
        .delete(`/api/RestaurantCommunication/${id}`)
        .then(() => {
          this.message = "Коммуникация успешно удалена";
          this.snackbar = true;
          this.dialogDelete = false;
          this.selectedCommunication = null;
          this.getRestaurant();
          // Обновление списка (например, перезапрос ресторана)
          // this.getRestaurant();
        })
        .catch(() => {
          this.message = "Ошибка при удалении коммуникации";
          this.snackbar = true;
          this.dialogDelete = false;
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.selectedCommunication = null;

      // this.$nextTick(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem);
      //   this.editedIndex = -1;
      // });
    },

    handleButtonClick() {
      if (this.isEditing) {
        // Выполните метод для редактирования
        this.updateCommunication();
      } else {
        // Выполните метод для создания нового приложения
        this.createNewCommunication();
      }
    },
    confirmWorkTimeDelivery() {
      // Проверка, выбран ли режим работы
      if (!this.modalTimeDataDelivery.isUsingAllDaysDelivery && !this.modalTimeDataDelivery.isUsingTargetDaysDelivery) {
        this.snackbar = true;
        this.message = "Сначала выберите тип режима работы доставки";
        return;
      }

      // Функция форматирования времени в hh:mm:ss
      const formatTimeSpan = (time) => {
        const parts = time.split(":");
        return `${parts[0].padStart(2, "0")}:${parts[1].padStart(2, "0")}:00`;
      };

      let payload = {};

      // Если выбран Everyday
      if (this.modalTimeDataDelivery.isUsingAllDaysDelivery) {
        if (!this.modalTimeDataDelivery.allDayWorkStartDelivery || !this.modalTimeDataDelivery.allDayWorkEndDelivery) {
          this.snackbar = true;
          this.message = "Пожалуйста, заполните время начала и окончания доставки";
          return;
        }

        payload = {
          type: "Everyday",
          hoursGeneral: {
            openingTime: formatTimeSpan(this.modalTimeDataDelivery.allDayWorkStartDelivery),
            closingTime: formatTimeSpan(this.modalTimeDataDelivery.allDayWorkEndDelivery)
          },
          hoursSpecific: []
        };
      }

      // Если выбран Weekly
      if (this.modalTimeDataDelivery.isUsingTargetDaysDelivery) {
        const selectedDays = this.weekDaysDelivery
          .filter(day => day.isEnabled)
          .map(day => {
            if (!day.start || !day.end) {
              this.snackbar = true;
              this.message = `Пожалуйста, заполните время для дня ${day.name}`;

            }
            return {
              dayOfWeek: day.api,
              isEnabled: day.isEnabled,
              openingTime: formatTimeSpan(day.start),
              closingTime: formatTimeSpan(day.end)
            };
          });

        if (selectedDays.length === 0) {
          this.snackbar = true;
          this.message = "Не выбран ни один день для доставки по дням недели";
          return;
        }

        payload = {
          type: "Weekly",
          hoursGeneral: null,
          hoursSpecific: selectedDays
        };
      }

      // Отправка на API
      this.$http
        .put(`/api/RestaurantDelivery/${this.$route.params.restaurantId}/TimeTable`, payload)
        .then(() => {
          this.snackbar = true;
          this.message = "Режим доставки успешно сохранён!";
          this.getRestaurant();
          this.dialogWorkTimeDelivery = false;
        })
        .catch((error) => {
          this.snackbar = true;
          this.error = error;
          this.message = "Ошибка при сохранении доставки.";
        });
    },
    confirmWorkTime() {
      // Проверка, выбран ли режим работы
      if (!this.modalTimeData.isUsingAllDays && !this.modalTimeData.isUsingTargetDays) {
        this.snackbar = true;
        this.message = "Сначала выберите тип режима работы";
        return;
      }

      // Функция форматирования времени в hh:mm:ss
      const formatTimeSpan = (time) => {
        const parts = time.split(":");
        return `${parts[0].padStart(2, "0")}:${parts[1].padStart(2, "0")}:00`;
      };

      let payload = {};

      // Если выбран Everyday
      if (this.modalTimeData.isUsingAllDays) {
        if (!this.modalTimeData.allDayWorkStart || !this.modalTimeData.allDayWorkEnd) {
          this.snackbar = true;
          this.message = "Пожалуйста, заполните время начала и окончания рабочего дня";
          return;
        }

        payload = {
          type: "Everyday",
          hoursGeneral: {
            openingTime: formatTimeSpan(this.modalTimeData.allDayWorkStart),
            closingTime: formatTimeSpan(this.modalTimeData.allDayWorkEnd)
          },
          hoursSpecific: []
        };
      }

      // Если выбран Weekly
      if (this.modalTimeData.isUsingTargetDays) {
        const selectedDays = this.weekDays
          .filter(day => day.isEnabled)
          .map(day => {
            if (!day.start || !day.end) {
              this.snackbar = true;
              this.message = `Пожалуйста, заполните время для дня ${day.name}`;
              throw new Error("Не заполнено время для всех выбранных дней");
            }
            return {
              dayOfWeek: day.api,
              isEnabled: day.isEnabled,
              openingTime: formatTimeSpan(day.start),
              closingTime: formatTimeSpan(day.end)
            };
          });

        if (selectedDays.length === 0) {
          this.snackbar = true;
          this.message = "Не выбран ни один день для режима по дням недели";
          return;
        }

        payload = {
          type: "Weekly",
          hoursGeneral: null,
          hoursSpecific: selectedDays
        };
      }

      // Отправка на API
      this.$http
        .put(`/api/Restaurant/${this.$route.params.restaurantId}/TimeTable`, payload)
        .then(() => {
          this.snackbar = true;
          this.message = "Режим работы успешно сохранён!";
          this.getRestaurant();
          this.dialogWorkTime = false;
        })
        .catch((error) => {
          this.snackbar = true;
          this.error = error;
          this.message = "Ошибка при сохранении режима работы.";
        });
    },
    createNewCommunication() {
      const newCommunication = {
        name: this.nameCommunication || null,
        restaurantId: this.$route.params.restaurantId || null,
        channelType: this.communicationChanelType || null,
        type: this.communicationTypes.find(ct => ct.value === this.communicationType)?.label || null

      };


      if (!newCommunication.name || !newCommunication.channelType || !newCommunication.type) {
        this.snackbar = true;
        this.message = "Пожалуйста, заполните все поля";
        return;
      }

      this.$http
        .post("/api/RestaurantCommunication", newCommunication)
        .then(() => {
          this.closeCreate();
          this.snackbar = true;
          this.message = "Коммуникация успешно создана";
          this.getRestaurant();   // Обновляем данные ресторана после создания коммуникации

        })
        .catch((error) => {
          this.error = error;
          this.snackbar = true;
          this.message = "Ошибка при создании коммуникации";
        });
    },
  formatDisplayDate(date) {
    if (!date) return '';
    const [year, month, day] = date.split('-');
    return `${day}.${month}.${year}`;
  },
    closeCreate() {
      this.dialogCreate = false;
      this.communicationType = "";
      this.communicationChanelType = "";
      this.isEditing = false;
      this.nameCommunication = "";
      // this.isUsingAllDays = false;
      // this.isUsingTargetDays = false;
      this.dialogWorkTime = false;
      this.weekDays = this.originalWeekDays.map(day => ({ ...day }));
      this.modalTimeData.isUsingTargetDays = this.originalTimeData.isUsingTargetDays;
      this.modalTimeData.isUsingAllDays = this.originalTimeData.isUsingAllDays;


      this.weekDaysDelivery = this.originalWeekDaysDelivery.map(day => ({ ...day }));
      this.modalTimeDataDelivery.isUsingTargetDaysDelivery = this.originalTimeDataDelivery.isUsingTargetDaysDelivery;
      this.modalTimeDataDelivery.isUsingAllDaysDelivery = this.originalTimeDataDelivery.isUsingAllDaysDelivery;

      // Очищаем время (если одиночные)
      // this.allDayWorkStart = "";
      // this.allDayWorkEnd = "";
      // Очищаем дни недели (если используешь weekDays)
      // if (this.weekDays) {
      //   this.weekDays.forEach(day => {
      //     day.start = "";
      //     day.end = "";
      //   });
      // }
    },

    closeDialog() {
      this.dialogWorkTime = false;
      this.dialogCreate = false;
      this.communicationType = "";
      this.communicationChanelType = "";
      this.isEditing = false;
      this.nameCommunication = "";
      this.weekDays = this.originalWeekDays.map(day => ({ ...day }));
      this.modalTimeData.isUsingTargetDays = this.originalTimeData.isUsingTargetDays;
      this.modalTimeData.isUsingAllDays = this.originalTimeData.isUsingAllDays;

      this.weekDaysDelivery = this.originalWeekDaysDelivery.map(day => ({ ...day }));
      this.modalTimeDataDelivery.isUsingTargetDaysDelivery = this.originalTimeDataDelivery.isUsingTargetDaysDelivery;
      this.modalTimeDataDelivery.isUsingAllDaysDelivery = this.originalTimeDataDelivery.isUsingAllDaysDelivery;

      // this.isUsingAllDays = false;
      // this.isUsingTargetDays = false;
      // Очищаем время
      // this.allDayWorkStart = "";
      // this.allDayWorkEnd = "";

      // Очищаем дни недели
      // if (this.weekDays) {
      //   this.weekDays.forEach(day => {
      //     day.start = "";
      //     day.end = "";
      //   });
      // }
    },

    createCommunication() {
      this.dialogCreate = true;
      this.communicationType = "";
      this.communicationChanelType = "";
      this.isEditing = false;
      this.nameCommunication = "";
    },
    createWorkTime() {
      this.modalTimeData = JSON.parse(JSON.stringify(this.originalTimeData));
      this.dialogWorkTime = true;
    },
    createDeliveryTime() {
      this.modalTimeDataDelivery = JSON.parse(JSON.stringify(this.originalTimeDataDelivery));
      this.dialogWorkTimeDelivery = true;
    },
    deleteCommunicationModal(item) {
      this.selectedCommunication = item;
      this.dialogDelete = true;
      // this.editedItem = Object.assign({}, item);
      // this.editedIndex = index;
    },

    accountList() {
      this.$http
        .put("/api/Account/PagedList", {
          pageNumber: 1,
          pageSize: -1,
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          // Предполагается, что `response.data.items` содержит массив объектов
          this.accounts = response.data.items.map((item) => ({
            id: item.id, // Уникальный идентификатор
            name: item.name || "Не указано", // Название аккаунта

          }));

          // Устанавливаем общее количество элементов и проверяем наличие данных
          this.totalItems = response.data.totalCount;
          this.showNoDataMessage = this.totalItems === 0;
        })
        .catch((error) => {
          this.error = error;
        });
    },
    appList() {
      this.$http
        .put("/api/Application/PagedList", {
          pageNumber: 1,
          pageSize: -1,
          headers: {
            'Content-Type': 'application/json',
          },
          //             filters: [
          //   {
          //     property: "Name",
          //     operator: "contains",
          //     value: this.search.toLowerCase(),
          //   }
          // ],
        })
        .then((response) => {
          this.applications = response.data.items.map((item) => ({
            id: item.id, // Уникальный идентификатор
            brandName: item.brandName || "Не указано", // Название аккаунта

          }));
          //this.totalPages = response.data.totalPages; // Общее количество страниц
          this.totalItems = response.data.totalCount;
          this.showNoDataMessage = this.totalItems === 0;
        })
        .catch((error) => {
          this.error = error;
        });
    },
    async copyLink(type) {
      let link = '';

      if (type === 'app') {
        link = `Ваша универсальная ссылка для скачивание приложения ${this.restaurant.application?.brandName} - https://appqr.ozo.direct/?applicationId=${this.restaurant.application?.id}`;
      } else if (type === 'menu') {
        link = `Ссылка на QR меню ресторана ${this.restaurant.name} (${this.restaurant.address}) - https://menu.rst.ozo.direct/?restaurantId=${this.$route.params.restaurantId.toUpperCase()}`;
      }

      try {
        await navigator.clipboard.writeText(link);
        this.snackbar = true;
        this.message = `Ссылка скопирована`;
      } catch (err) {
        console.error('Ошибка копирования:', err);
        this.message = 'Не удалось скопировать ссылку';
      }
    },
    isUsingDeliveryLog() {
      console.log('isUsingDelivery:', this.isUsingDelivery, 'Type:', typeof this.isUsingDelivery);

      // Проверка изменения значения
      if (this.isUsingDelivery !== this.restaurant.isUsingDelivery || this.isUsingBonus !== this.restaurant.isUsingBonus) {
        console.log('isUsingDelivery has changed');

        this.dataChanged = true; // Устанавливаем dataChanged в true
        return; // Завершаем выполнение метода
      }

      // Если значение не изменилось
      this.dataChanged = this.isDataChanged(); // Сбрасываем dataChanged в false
    },
    isUsingBonusLog() {
      console.log('isUsingBonus:', this.isUsingBonus, 'Type:', typeof this.isUsingBonus);

      if (this.isUsingBonus !== this.restaurant.isUsingBonus) {
        console.log('isUsingBonus has changed');
        this.dataChanged = true; // Запуск isDataChanged
      } else {
        console.log('isUsingBonus remains unchanged');
        this.dataChanged = false; // Сбрасываем dataChanged, если значения равны
      }

    },
    formatApiTime(time) {
      if (!time || typeof time !== "string") return "";
      return time.slice(0, 5); // "10:00:00" → "10:00"
    },

    getRestaurant() {
      this.$http
        .get(`/api/Restaurant/${this.$route.params.restaurantId}`)
        .then((response) => {
          this.restaurant = response.data;

          // Основные данные ресторана
          this.name = this.restaurant.name || "Не указан";
          this.latitude = this.restaurant.latitude ?? "Не указана";
          this.longitude = this.restaurant.longitude ?? "Не указана";
          this.description = this.restaurant.description || "Не указан";
          this.phoneNumber = this.restaurant.phoneNumber || "Не указан";
          this.address = this.restaurant.address || "Не указан";
          this.minOrderAmount = this.restaurant.minOrderAmount ?? "Не указан";
          this.isUsingDelivery = this.restaurant.isUsingDelivery;
          this.isUsingBonus = this.restaurant.isUsingBonus;
          this.resReleaseDate = this.restaurant.releaseDate.split('T')[0] || null;

          const timeTable = this.restaurant.timeTable;
          const timeTableDelivery = this.restaurant.restaurantDelivery.timeTable;

          // Сбрасываем все
          this.originalTimeData = {
            isUsingAllDays: false,
            isUsingTargetDays: false,
            allDayWorkStart: "",
            allDayWorkEnd: ""
          };
          this.weekDays.forEach(day => {
            day.start = "";
            day.end = "";
            day.isEnabled = false;
          });

          this.originalTimeDataDelivery = {
            isUsingAllDaysDelivery: false,
            isUsingTargetDaysDelivery: false,
            allDayWorkStartDelivery: "",
            allDayWorkEndDelivery: ""
          };
          this.weekDaysDelivery.forEach(day => {
            day.start = "";
            day.end = "";
            day.isEnabled = false;
          });



          // Обработка тайм-таблицы
          if (timeTable) {
            if (timeTable.type === "Everyday") {
              this.originalTimeData.isUsingAllDays = true;
              this.originalTimeData.isUsingTargetDays = false;

              this.originalTimeData.allDayWorkStart = this.formatApiTime(
                timeTable.hoursGeneral?.openingTime
              );
              this.originalTimeData.allDayWorkEnd = this.formatApiTime(
                timeTable.hoursGeneral?.closingTime
              );
            } else if (timeTable.type === "Weekly" && timeTable.hoursSpecific) {
              this.originalTimeData.isUsingAllDays = false;
              this.originalTimeData.isUsingTargetDays = true;

              // Подставляем данные для weekDays
              this.weekDays.forEach(day => {
                const apiDay = timeTable.hoursSpecific.find(d => d.dayOfWeek === day.api);
                if (apiDay) {
                  day.start = this.formatApiTime(apiDay.openingTime);
                  day.end = this.formatApiTime(apiDay.closingTime);
                  day.isEnabled = apiDay.isEnabled;
                } else {
                  day.start = "";
                  day.end = "";
                  day.isEnabled = false;
                }
              });

              // Сохраняем оригинальное состояние для восстановления при закрытии
              this.originalWeekDays = this.weekDays.map(day => ({ ...day }));
            }
          }


          if (timeTableDelivery) {
            if (timeTableDelivery.type === "Everyday") {
              this.originalTimeDataDelivery.isUsingAllDaysDelivery = true;
              this.originalTimeDataDelivery.isUsingTargetDaysDelivery = false;

              this.originalTimeDataDelivery.allDayWorkStartDelivery = this.formatApiTime(
                timeTableDelivery.hoursGeneral?.openingTime
              );
              this.originalTimeDataDelivery.allDayWorkEndDelivery = this.formatApiTime(
                timeTableDelivery.hoursGeneral?.closingTime
              );
            } else if (timeTableDelivery.type === "Weekly" && timeTableDelivery.hoursSpecific) {
              this.originalTimeDataDelivery.isUsingAllDaysDelivery = false;
              this.originalTimeDataDelivery.isUsingTargetDaysDelivery = true;

              // Подставляем данные для weekDays
              this.weekDaysDelivery.forEach(day => {
                const apiDay = timeTableDelivery.hoursSpecific.find(d => d.dayOfWeek === day.api);
                if (apiDay) {
                  day.start = this.formatApiTime(apiDay.openingTime);
                  day.end = this.formatApiTime(apiDay.closingTime);
                  day.isEnabled = apiDay.isEnabled;
                } else {
                  day.start = "";
                  day.end = "";
                  day.isEnabled = false;
                }
              });

              // Сохраняем оригинальное состояние для восстановления при закрытии
              this.originalWeekDaysDelivery = this.weekDaysDelivery.map(day => ({ ...day }));
            }
          }

          // Загрузка изображений
          const apiHost = process.env.VUE_APP_IMAGE_API_HOST;
          if (this.restaurant.account) {
            this.account = this.restaurant.account;
            this.accountId = this.restaurant?.account?.id;
          }
          if (this.restaurant.application) {
            this.application = this.restaurant.application;
            this.applicationId = this.restaurant?.application?.id;
          }
          if (this.restaurant.restaurantBonusGroup) {
            this.restaurantBonusGroup = this.restaurant.restaurantBonusGroup;
            this.restaurantBonusGroupId = this.restaurant?.restaurantBonusGroup?.id;
            console.log(this.restaurantBonusGroupId, "ПОСТАВЛЕН")
          }
          if (this.restaurant) {
            this.uploadedImages = {
              headerLogoId: this.restaurant?.headerLogo?.imagePath
                ? apiHost + this.restaurant.headerLogo.imagePath
                : null,
              headerLogoDarkId: this.restaurant?.headerLogoDark?.imagePath
                ? apiHost + this.restaurant.headerLogoDark.imagePath
                : null,
              logoId: this.restaurant?.logo?.imagePath
                ? apiHost + this.restaurant.logo.imagePath
                : null,
              logoDarkId: this.restaurant?.logoDark?.imagePath
                ? apiHost + this.restaurant.logoDark.imagePath
                : null,
              backgroundImageId: this.restaurant?.backgroundImage?.imagePath
                ? apiHost + this.restaurant.backgroundImage.imagePath
                : null,
            };
            this.resImages = {
              headerLogoId: this.restaurant?.headerLogo?.id
                ? this.restaurant.headerLogo.id
                : null,
              headerLogoDarkId: this.restaurant?.headerLogoDark?.id
                ? this.restaurant.headerLogoDark.id
                : null,
              logoId: this.restaurant?.logo?.id
                ? this.restaurant.logo.id
                : null,
              logoDarkId: this.restaurant?.logoDark?.id
                ? this.restaurant.logoDark.id
                : null,
              backgroundImageId: this.restaurant?.backgroundImage?.id
                ? this.restaurant.backgroundImage.id
                : null,
            };
          }

          this.restaurantImageId = this.restaurant.backgroundImage?.id;
          this.$store.commit("setRootRestaurant", this.restaurant);
          this.loadBonusGroups();
          this.loading = true;
        })
        .catch((error) => {
          alert(error);
        });
    },
    async uploadImageBackgroundImage(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedImage = file;
        this.uploadedImageBackgroundImage = URL.createObjectURL(file);

        if (this.restaurant.backgroundImage === null) {
          // Если изображения нет, выполняем POST-запрос
          await this.uploadNewImage();
        } else {
          // Если изображение уже есть, выполняем PUT-запрос
          await this.updateExistingImage();
        }
      }
    },
    // async uploadNewImage() {
    //   try {
    //     const formData = new FormData();
    //     const config = {
    //     headers: {
    //       accept: "*/*",
    //       "Content-Type": "multipart/form-data",
    //     },
    //   };
    //     formData.append("imageFile", this.selectedImage);
    //     console.log(this.selectedImage)
    //     const response = await this.$http.post("/api/Image/Upload", formData, config);
    //     if (response.data?.id) {
    //       this.restaurantImageId = response.data.id;
    //       // await this.editRestaurant();
    //     }
    //   } catch (error) {
    //     console.error("Ошибка при загрузке нового изображения:", error);
    //   }
    // },
    // async updateExistingImage() {
    //   try {
    //     const formData = new FormData();
    //     formData.append("imageFile", this.selectedImage);
    //     const config = {
    //     headers: {
    //       accept: "*/*",
    //       "Content-Type": "multipart/form-data",
    //     },
    //   };
    //     await this.$http.put(`/api/Image/${this.restaurantImageId}`, formData,config);
    //     console.log("Изображение успешно обновлено");
    //   } catch (error) {
    //     console.error("Ошибка при обновлении изображения:", error);
    //   }
    // },
    async handleImageUpload(key, event) {
      const file = event.target.files[0];
      this.previousImage = null;
      if (file) {
        this.previousImage = this.uploadedImages[key];
        this.uploadedImages[key] = URL.createObjectURL(file);
        // this.resImages[key] = file;

        try {
          if (!this.resImages[key]) {
            // POST запрос для нового изображения
            await this.uploadNewImage(key, file);
          } else {
            // PUT запрос для обновления существующего изображения
            await this.updateExistingImage(key, file);
          }
        } catch (error) {
          console.error(`Ошибка загрузки изображения ${key}:`, error);
        }
      }
    },

    // POST запрос для нового изображения
    async uploadNewImage(key, file) {
      const formData = new FormData();
      formData.append("imageFile", file);
      try {
        const response = await this.$http.post("/api/Image/Upload", formData);
        if (response.data?.id) {
          this.resImages[key] = response.data.id;
          this.uploadedImages[key] = process.env.VUE_APP_IMAGE_API_HOST + response.data.imagePath;
          this.snackbar = true;
          this.message = `Новое изображение (${key}) успешно загруженно`;
        }
      } catch (error) {
        this.snackbar = true;
        this.message = `Ошибка загрузки нового изображения (${key})`;
      }
    },

    // PUT запрос для обновления существующего изображения
    async updateExistingImage(key, file) {
      const formData = new FormData();
      formData.append("imageFile", file);
      try {
        await this.$http.put(`/api/Image/${this.resImages[key]}`, formData);
        console.log(`Изображение (${key}) успешно обновлено`);
        this.snackbar = true;
        this.message = `Изображение (${key}) успешно обновлено`;
      } catch (error) {
        this.snackbar = true;
        this.message = `Ошибка обновления изображения (${key})`;
        this.uploadedImages[key] = this.previousImage;

      }
    },
    async updateRestaurantImageId() {
      try {
        await this.$axios.put("/api/Restaurant/UpdateImage", {
          restaurantId: this.selectedRestaurantId,
          imageId: this.restaurantImageId,
        });
        console.log("ID изображения успешно привязан к ресторану");
      } catch (error) {
        console.error("Ошибка при обновлении ресторана:", error);
      }
    },
    onChangeApp(selectedId) {
      if (selectedId === this.restaurant?.application?.id) {
        // console.log(this.restaurant?.application?.id)
        // console.log(selectedId);
        // console.log("ID не изменился, запрос не отправляется.");
        this.dataChanged = this.isDataChanged();
        return;
      }
      // Здесь вы обновляете название ресторана
      const selectedApp = this.applications.find(app => app.id === selectedId);

      if (selectedApp) {
        this.application = selectedApp;
        this.applicationId = selectedApp.id;
        // console.log("Данные успешно обновлены с новым ID:", selectedApp.id);
        this.dataChanged = true;
      }
      else {
        this.applicationId = this.restaurant.application.id;
      }
    },
    onChangeAccount(selectedId) {
      if (selectedId === this.restaurant?.account?.id) {
        console.log(this.restaurant?.account?.id)
        console.log(selectedId);
        console.log("ID не изменился, запрос не отправляется.");
        this.dataChanged = this.isDataChanged();
        return;
      }
      // Здесь вы обновляете название ресторана
      const selectedAcc = this.accounts.find(account => account.id === selectedId);

      if (selectedAcc) {
        this.account = selectedAcc;
        this.accountId = selectedAcc.id
        this.dataChanged = true;
        console.log("Данные успешно обновлены с новым ID:", selectedAcc.id);
      }
      else {
        this.accountId = this.restaurant.account.id;
      }
    },
    onChangeBonusGroup(selectedId) {
      if (selectedId === this.restaurant?.restaurantBonusGroup?.id) {
        // console.log(this.restaurant?.application?.id)
        // console.log(selectedId);
        // console.log("ID не изменился, запрос не отправляется.");
        this.dataChanged = this.isDataChanged();
        return;
      }
      // Здесь вы обновляете название ресторана
      const selectedBonusGroup = this.bonusGroups.find(BonusGroup => BonusGroup.id === selectedId);

      if (selectedBonusGroup) {
        this.bonusGroup = selectedBonusGroup;
        this.restaurantBonusGroupId = selectedBonusGroup.id;
        // console.log("Данные успешно обновлены с новым ID:", selectedApp.id);
        this.dataChanged = true;
      }
      else {
        this.restaurantBonusGroupId = this.restaurant.restaurantBonusGroup.id;
      }
    },
    async editRestaurant() {
      // console.log('Отправляем ресторан с полем stateCode:', this.restState);
      this.restaurant = {}
      // this.restaurant.stateCode = this.restState || null;
      this.restaurant.restaurantBonusGroupId = this.restaurantBonusGroupId;
      this.restaurant.accountId = this.accountId;
      this.restaurant.applicationId = this.applicationId;
      this.restaurant.name = this.name || null;
      this.restaurant.latitude = this.latitude || null;
      this.restaurant.longitude = this.longitude || null;
      this.restaurant.description = this.description || null;
      this.restaurant.phoneNumber = this.phoneNumber || null;
      this.restaurant.address = this.address || null;
      this.restaurant.minOrderAmount = this.minOrderAmount != null && this.minOrderAmount !== '' ? Number(this.minOrderAmount) : null;;
      this.restaurant.isUsingDelivery = this.isUsingDelivery;
      this.restaurant.isUsingBonus = this.isUsingBonus;
      this.restaurant.headerLogoId = this.resImages.headerLogoId || this.uploadedImages.headerLogoId;
      this.restaurant.headerLogoDarkId = this.resImages.headerLogoDarkId || this.uploadedImages.headerLogoDarkId;
      this.restaurant.logoId = this.resImages.logoId || this.uploadedImages.logoId;
      this.restaurant.logoDarkId = this.resImages.logoDarkId || this.uploadedImages.logoDarkId;
      this.restaurant.backgroundImageId = this.resImages.backgroundImageId || this.uploadedImages.backgroundImageId;
      this.restaurant.releaseDate = this.resReleaseDate;
      if (!this.name || this.name.trim() === '') {
        this.snackbar = true;
        this.message = "Название ресторана обязательно для заполнения";
        return;
      }
      if (this.latitude === null || this.latitude === undefined || this.latitude === '') {
        this.snackbar = true;
        this.message = "Широта ресторана обязательна для заполнения";
        return;
      }

      if (this.longitude === null || this.longitude === undefined || this.longitude === '') {
        this.snackbar = true;
        this.message = "Долгота ресторана обязательна для заполнения";
        return;
      }
      if (!this.description || this.description.trim() === '') {
        this.snackbar = true;
        this.message = "Описание ресторана обязательно для заполнения";
        return;
      }
      if (!this.address || this.address.trim() === '') {
        this.snackbar = true;
        this.message = "Адрес ресторана обязателен для заполнения";
        return;
      }
      if (this.minOrderAmount === '' || this.minOrderAmount === null || this.minOrderAmount === undefined || isNaN(this.minOrderAmount)) {
        this.snackbar = true;
        this.message = "Минимальная сумма заказа обязательна для заполнения";
        return;
      }
      if (!this.phoneNumber || this.phoneNumber.trim() === '') {
        this.snackbar = true;
        this.message = "Номер телефона для связи клиентов обязателен для заполнения";
        return;
      }
      this.$http
        .put(`/api/Restaurant/${this.$route.params.restaurantId}`, this.restaurant, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(() => {
          console.log('Ответ сервера после изменения ресторана:', this.restaurant);
          this.snackbar = true;
          this.message = "Ресторан успешно изменен";
          this.getRestaurant();
          this.dataChanged = false;
          //Пока редирект выключен
          // setTimeout(() => {
          //   this.$router.push({ path: `/RestaurantRoot/` });
          // }, 3000);
        })
        .catch((error) => {
          //alert(error);
          this.snackbar = true;
          if (error.response && error.response.status === 400) {
            this.message = "Заполните данные";
          } else {
            this.message = "Не удалось изменить ресторан";
          }
        });
    },
    updateDataChangedState(changed) {
      this.dataChanged = changed;
    },

    validateInput() {
      // --- для minOrderAmount ---
      this.minOrderAmount = this.minOrderAmount.replace(/\D/g, "");
      if (this.minOrderAmount) {
        this.minOrderAmount = Number(this.minOrderAmount).toLocaleString("ru-RU");
      }

      // --- для latitude ---
      if (this.latitude !== undefined && this.latitude !== null) {
        let lat = this.latitude.toString().replace(/[^0-9.]/g, "");
        const latParts = lat.split(".");
        if (latParts.length > 2) {
          lat = latParts[0] + "." + latParts.slice(1).join("");
        }
        this.latitude = lat ? Number(lat) : null;  // <-- число
      }

      // --- для longitude ---
      if (this.longitude !== undefined && this.longitude !== null) {
        let lng = this.longitude.toString().replace(/[^0-9.]/g, "");
        const lngParts = lng.split(".");
        if (lngParts.length > 2) {
          lng = lngParts[0] + "." + lngParts.slice(1).join("");
        }
        this.longitude = lng ? Number(lng) : null; // <-- число
      }
    },
    formatPhone() {
      if (this.phoneNumber === "7") {
        this.phoneNumber = "+7 (7"; // Автоматически добавляем второй 7
      }
    },
    logDeliveryAvailability() {
      console.log("Delivery availability changed to:", this.isDeliveryAvailable);
      console.log("Delivery equals to :", this.isDeliveryAvailable !== this.originalData.restaurantDelivery.isDeliveryAvailable);
    },

    onInputChange() {

      this.dataChanged = this.isDataChanged();
    },

    isDataChanged() {

      return (
        this.name !== this.restaurant.name ||
        this.latitude != this.restaurant.latitude ||
        this.longitude != this.restaurant.longitude ||
        this.description !== this.restaurant.description ||
        this.phoneNumber.replace(/[^\d+]/g, '') !== this.restaurant.phoneNumber ||
        this.address !== this.restaurant.address ||
        this.minOrderAmount != this.restaurant.minOrderAmount ||
        this.isUsingDelivery !== this.restaurant.isUsingDelivery ||
        this.isUsingBonus !== this.restaurant.isUsingBonus
        // Добавьте другие условия по необходимости
      );
    },

    toggleSwitch() {
      // Меняем значение isDeliveryAvailable при клике на "switch"
      //this.isDeliveryAvailable = !this.isDeliveryAvailable;
      console.log(this.isDeliveryAvailable);
      console.log(this.originalData.isDeliveryAvailable);

      // Добавляем дополнительный вывод для проверки
      console.log("toggleSwitch method has been called");
    },

    uploadImageLogoWhite(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedImage = file;
        this.uploadedImageLogoWhite = URL.createObjectURL(file);
      }
    },
    uploadImageLogoDark(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedImage = file;
        this.uploadedImageLogoDark = URL.createObjectURL(file);
      }
    },
    uploadImageHeaderLogo(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedImage = file;
        this.uploadedImageHeaderLogo = URL.createObjectURL(file);
      }
    },
    uploadImageHeaderLogoDark(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedImage = file;
        this.uploadedImageHeaderLogoDark = URL.createObjectURL(file);
      }
    },
    loadBonusGroups() {
      this.$http
        .put("/api/RestaurantBonusGroup/PagedList", {
          pageNumber: 1,
          pageSize: -1,
          headers: {
            'Content-Type': 'application/json',
          },
          filters: [
            // {
            //   property: "accountId",
            //   operator: "eq",
            //   value: this.accountId,
            // }
          ],
        })
        .then(({ data }) => {
          // this.bonusGroups = data.items || [];
          this.bonusGroups = data.items.map((item) => ({
            id: item.id, // Уникальный идентификатор
            name: item.name || "Не указано", // Название аккаунта
          }));
        })
        .catch(() => {
          this.snackbar = true;
          this.message = "Ошибка загрузки бонусных групп";
        });
    }
    // uploadImageBackgroundImage(event) {
    //   const file = event.target.files[0];
    //   if (file) {
    //     this.selectedImage = file;
    //     this.uploadedImageBackgroundImage = URL.createObjectURL(file);
    //   }
    // },
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
    weeklyTable() {
      const table = this.restaurant?.timeTable;

      if (!table || table.type !== "Weekly") {
        return [];
      }

      const specific = table.hoursSpecific || [];

      // для каждого дня недели ищем данные из API
      return this.weekDays.map(day => {
        const apiDay = specific.find(item => item.dayOfWeek === day.api);

        if (apiDay) {
          // если день есть в API
          return {
            name: day.name,
            isEnabled: apiDay.isEnabled,
            start: this.formatApiTime(apiDay.openingTime),
            end: this.formatApiTime(apiDay.closingTime)
          };
        }

        // если дня нет в API — считаем его закрытым
        return {
          name: day.name,
          isEnabled: false,
          start: "",
          end: ""
        };
      });
    },
    weeklyTableDelivery() {
      const table = this.restaurant?.restaurantDelivery.timeTable;

      if (!table || table.type !== "Weekly") {
        return [];
      }

      const specific = table.hoursSpecific || [];

      // для каждого дня недели ищем данные из API
      return this.weekDaysDelivery.map(day => {
        const apiDay = specific.find(item => item.dayOfWeek === day.api);

        if (apiDay) {
          // если день есть в API
          return {
            name: day.name,
            isEnabled: apiDay.isEnabled,
            start: this.formatApiTime(apiDay.openingTime),
            end: this.formatApiTime(apiDay.closingTime)
          };
        }

        // если дня нет в API — считаем его закрытым
        return {
          name: day.name,
          isEnabled: false,
          start: "",
          end: ""
        };
      });
    },
    hasTimeTable() {
      const table = this.restaurant?.timeTable;
      if (!table) return false;

      // Everyday
      if (table.type === "Everyday" && table.hoursGeneral) {
        return Boolean(
          table.hoursGeneral.openingTime &&
          table.hoursGeneral.closingTime
        );
      }

      // Weekly
      if (table.type === "Weekly" && Array.isArray(table.hoursSpecific)) {
        return table.hoursSpecific.some(item => item.isEnabled === true);
      }

      return false;
    },
    hasTimeTableDelivery() {
      const table = this.restaurant?.restaurantDelivery.timeTable;
      if (!table) return false;

      // Everyday
      if (table.type === "Everyday" && table.hoursGeneral) {
        return Boolean(
          table.hoursGeneral.openingTime &&
          table.hoursGeneral.closingTime
        );
      }

      // Weekly
      if (table.type === "Weekly" && Array.isArray(table.hoursSpecific)) {
        return table.hoursSpecific.some(item => item.isEnabled === true);
      }

      return false;
    },
    sortedCommunications() {
      if (!this.restaurant?.restaurantCommunications) return [];
      return [...this.restaurant.restaurantCommunications].sort((a, b) => {
        const nameA = this.communicationTypesTranslation[a.type] || '';
        const nameB = this.communicationTypesTranslation[b.type] || '';
        return nameA.localeCompare(nameB, 'ru');
      });
    },

    translatedCommunicationTypes() {
      return this.communicationTypes.map(item => ({
        ...item,
        label: this.communicationTypesTranslation[item.label] || item.label
      }));
    },

    translatedCommunicationChanelTypes() {
      return this.communicationChanelTypes.map(item => ({
        ...item,
        label: this.communicationChanelTypesTranslation[item.label] || item.label
      }));
    },
    hasLinks() {
      return (
        this.restaurant &&
        this.restaurant.application &&
        this.restaurant.application.links &&
        this.restaurant.application.links.length > 0
      );
    }
  },
  mounted() {
    // this.initialize();
    //   this.getManufacturers();
    this.getRestaurant();
  },
  created() {
    this.accountList();
    this.appList();
    // this.currentImageId = this.responseData.images[0].id;
    this.uploadedImageLogoWhite =
      process.env.VUE_APP_IMAGE_API_HOST + this.responseData?.logo?.imagePath;
    this.uploadedImageLogoDark =
      process.env.VUE_APP_IMAGE_API_HOST + this.responseData?.logoDark?.imagePath;
    this.uploadedImageHeaderLogo =
      process.env.VUE_APP_IMAGE_API_HOST + this.responseData?.headerLogo?.imagePath;
    this.uploadedImageHeaderLogoDark =
      process.env.VUE_APP_IMAGE_API_HOST + this.responseData?.headerLogoDark?.imagePath;
    this.uploadedImageBackgroundImage =
      process.env.VUE_APP_IMAGE_API_HOST +
      this.responseData?.backgroundImage?.imagePath;
    // this.legalAdress = this.responseData.address;
    // this.actualAdress = this.responseData.address;
    // this.FIOHEAD = this.responseData.account.name;
  },


};
</script>




<style lang="scss">
.page-title {
  color: rgb(50, 60, 77);
  font-family: Inter;
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
  letter-spacing: 0%;
  text-align: left;
}

.restaurant-title-adress {
  color: rgb(50, 60, 77);
  font-family: Inter;
  font-size: 24px;
  font-weight: 400;
  line-height: 29px;
  letter-spacing: 0%;
  text-align: left;
}

@media (min-width: 1264px) {
  .container {
    //1185px дефолтное название если что то ломаться начнется на маленьких мониторах
    max-width: 100% !important;
  }
}

@media (min-width: 960px) {

  //900 дефолтное название если что то ломаться начнется на маленьких мониторах
  .container {
    max-width: 100% !important;
  }
}
</style>